/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';

import store from '../../../../components/stores/Store';

import { getDevelopers } from '../../../../db/DeveloperRequestHandler';

import { getTrades } from '../../../../db/TradeRequestHandler';
import { getIfFuncAuthorized } from '../../../../utils/CheckSomething';

import { exportExcel } from '../../../../utils/ExcelHandler';

const styles = {
  root: {},
  textField: {
    width: '15ch',
  },
  formControl: {
    margin: '10px',
    // width: '20ch',
    minWidth: '20ch',
  },
  rootform: {
    textAlign: 'left',
  },
  button: {
    marginLeft: '10px',
    marginTop: '10px',
  }
};
// NavigateLeft
class SelectionOfOrderManagementInner extends Component {
  constructor() {
    super();
    store.clearTableConfig();
    store.setSelections({
      subarea: '', // 区域
      orderNumber: '',  // 订单号
      developerName: '', // 开发商
      propertyName: '', // 楼盘名称*
      ticketHolder: '', // 被搬迁户
      buyer: '', // 房票使用人
      paymentMethod: '', // 支付方式：‘1’-房票支付，‘2’-房票支付+现金转账。
      orderStatus: '', // '1'-未提交，'2'-已提交，'3'-已动迁审核，'4'-已财资确认，'9'-已拒绝	
    });
    this.state = {
    };
    this.handleChange = this.handleChange.bind(this);
    this.search = this.search.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
  }

  async componentDidMount() {
    this.getDevelopers();
    this.search();
    store.search = this.search;
    store.clearLinesSelected();
  }
  componentWillUnmount() { }

  async getDevelopers() {
    console.log(`----- send req of  getDevelopers`);
    const rst = await getDevelopers({});
    console.log(`----- rst of getDevelopers: `, rst);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '房产商查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      this.setState({ developerSelections: rst.data });
      return true;
    }
  }

  handleChange(event) {
    this.setState({ age: event.target.value });
  }

  async search() {
    if (!getIfFuncAuthorized('交易管理-交易记录管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }
    store.clearLinesSelected();
    const selections = {
      subarea: ['like', store.selections.subarea], // 订单号
      orderNumber: ['like', store.selections.orderNumber], // 订单号
      developerName: ['like', store.selections.developerName], // 开发商
      propertyName: ['like', store.selections.propertyName], // 楼盘名称
      ticketHolder: ['like', store.selections.ticketHolder], // 被搬迁户
      buyer: ['like', store.selections.buyer], // 房票使用人
      paymentMethod: ['equal', store.selections.paymentMethod],  // 支付方式：‘1’-房票支付，‘2’-房票支付+现金转账。
      orderStatus: ['equal', store.selections.orderStatus],    // '1'-未提交，'2'-已提交，'3'-已动迁审核，'4'-已财资确认，'9'-已拒绝
    };
    console.log('----- 搜索：', selections);
    const rst = await getTrades({
      where: selections,
      orderBy: store.tableConfig.orderBy || 'orderNumber',
      order: store.tableConfig.order || 'desc',
      currentPage: store.tableConfig.currentPage, // 当前页
      rowsPerPage: store.tableConfig.rowsPerPage, // 每页条数
    });

    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setTable(rst.data);
      store.setTableCount(rst.count || 0);
      return true;
    }
  }

  async exportExcel() {
    let rawData;
    const selections = {
      orderNumber: ['like', store.selections.orderNumber], // 订单号
      subarea: ['like', store.selections.subarea], // 区域
      developerName: ['like', store.selections.developerName], // 开发商
      propertyName: ['like', store.selections.propertyName], // 楼盘名称
      ticketHolder: ['like', store.selections.ticketHolder], // 被搬迁户
      buyer: ['like', store.selections.buyer], // 房票使用人
      paymentMethod: ['equal', store.selections.paymentMethod],  // 支付方式：‘1’-房票支付，‘2’-房票支付+现金转账。
      orderStatus: ['equal', store.selections.orderStatus],    // '1'-未提交，'2'-已提交，'3'-已动迁审核，'4'-已财资确认，'9'-已拒绝
    };
    console.log('----- 搜索：', selections);
    const rst = await getTrades({
      where: selections,
      order: store.tableConfig.order || 'desc',
      orderBy: store.tableConfig.orderBy || 'orderNumber',
      currentPage: 0, // 当前页
      rowsPerPage: 9999, // 每页条数
    });

    if (rst.code === 'error') {
      store.openMessageDialogOpen('导出数据查询错误');
      return true;
    } else if (rst.code === 'success') {
      rawData = rst.data;
    }

    // 表头
    const xlsxHeader = {
      orderNumber: '订单号',
      subarea: '区域',
      orderStatus: '订单状态',
      transactionTime: '交易时间',
      entryTime: '入账时间',
      developerName: '开发商名称',
      housingResources: '房源',
      ticketHolder: '被搬迁户',
      buyer: '房票使用人',
      unitPrice: '房源单价',
      actualPrice: '实际单价',
      unitperPrice: '单价差额',
      transactionAmount: '交易金额',
      roomTicket: '房票支付',
      cashTransfer: '	现金转账',
      paymentMethod: '支付方式',
    };

    // 数据内容
    const data = [];
    for (let index = 0; index < rawData.length; index++) {
      const element = rawData[index];
      const newElement = {};
      newElement.subarea = element.subarea;
      newElement.orderNumber = element.orderNumber;
      newElement.orderStatus =
        ({ '1': '未提交', '2': '已提交', '3': '已动迁审核', '4': '已财资确认', '9': '已拒绝' })
        [element.orderStatus];
      newElement.transactionTime = element.transactionTime;
      newElement.entryTime = element.entryTime;
      newElement.developerName = element.developerName;
      newElement.housingResources = element.housingResources;
      newElement.ticketHolder = element.ticketHolder;
      newElement.buyer = element.buyer;
      newElement.unitPrice = element.unitPrice;
      newElement.actualPrice = element.actualPrice;
      newElement.unitperPrice = element.unitperPrice;
      newElement.transactionAmount = element.transactionAmount;
      newElement.roomTicket = element.roomTicket;
      newElement.cashTransfer = element.cashTransfer;
      newElement.paymentMethod =
        ['', '房票支付', '房票支付+现金转账'][element.paymentMethod];
      data.push(newElement);
    }


    // 文件名
    const now = new Date();
    const xlsxName =
      `交易记录表`
      + `${(Array(4).join(0) + now.getFullYear()).slice(-4)}`
      + `${(Array(2).join(0) + (now.getMonth() + 1)).slice(-2)}`
      + `${(Array(2).join(0) + now.getDate()).slice(-2)}-`
      + `${(Array(2).join(0) + now.getHours()).slice(-2)}`
      + `${(Array(2).join(0) + now.getMinutes()).slice(-2)}`
      + `${(Array(2).join(0) + now.getSeconds()).slice(-2)}-`
      + `${(Array(4).join(0) + (Math.round(Math.random() * 9999))).slice(-4)}`;

    const file = exportExcel(data, xlsxHeader, xlsxName);
    return file;
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {/* <Button color="primary" variant="contained" aria-label="contained primary button group" className={classes.button}>动迁办确认</Button> */}
          {/* <Button color="primary" variant="contained" aria-label="contained primary button group" className={classes.button}>财资审核</Button> */}
          {(getIfFuncAuthorized('交易管理-交易记录管理-导出Excel')) && (
            <Button
              color="primary"
              variant="contained"
              onClick={e => this.exportExcel()}
              className={classes.button}
            >
              导出Excel
            </Button>
          )}
        </form>
        <form className={classes.rootform} noValidate autoComplete="off">
          <TextField
            id="outlined-number"
            label="订单号"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.orderNumber || ''}
            onChange={e => store.onChangeSelection(e, 'orderNumber')}
          />
          <TextField
            id="outlined-number"
            label="区域"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.subarea || ''}
            onChange={e => store.onChangeSelection(e, 'subarea')}
          />
          <TextField
            id="outlined-number"
            label="开发商"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.developerName || ''}
            onChange={e => store.onChangeSelection(e, 'developerName')}
          />
          <TextField
            id="outlined-number"
            label="楼盘名称"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.propertyName || ''}
            onChange={e => store.onChangeSelection(e, 'propertyName')}
          />
          <TextField
            id="outlined-number"
            label="被搬迁户"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.ticketHolder || ''}
            onChange={e => store.onChangeSelection(e, 'ticketHolder')}
          />
          <TextField
            id="outlined-number"
            label="房票使用人"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.buyer || ''}
            onChange={e => store.onChangeSelection(e, 'buyer')}
          />

          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-outlined-label" style={{ marginTop: '-8px' }}>支付方式</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={store.selections.paymentMethod || ''}
              onChange={e => store.onChangeSelection(e, 'paymentMethod')}
              label="支付方式"
              margin="dense"
            >
              <MenuItem value="">
                <em>请选择</em>
              </MenuItem>
              <MenuItem value={'1'}>房票支付</MenuItem>
              <MenuItem value={'2'}>房票支付+现金转账</MenuItem>
            </Select>
          </FormControl>


          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-outlined-label" style={{ marginTop: '-8px' }}>订单状态</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={store.selections.orderStatus || ''}
              onChange={e => store.onChangeSelection(e, 'orderStatus')}
              label="订单状态"
              margin="dense"
            >
              <MenuItem value="">
                <em>请选择</em>
              </MenuItem>
              <MenuItem value={'1'}>未提交</MenuItem>
              <MenuItem value={'2'}>已提交</MenuItem>
              <MenuItem value={'3'}>已动迁审核</MenuItem>
              <MenuItem value={'4'}>已财资确认</MenuItem>
              <MenuItem value={'9'}>已拒绝</MenuItem>
            </Select>
          </FormControl>
          <Button color="primary" variant="contained" aria-label="contained primary button group" className={classes.button} onClick={this.search}>搜索</Button>
          <Button color="primary" variant="contained" aria-label="contained primary button group" className={classes.button} onClick={e => store.clearSelection()}>清除搜索</Button>
          {/* <Button color="primary" variant="contained" aria-label="contained primary button group" className={classes.button}>表格设置</Button> */}
        </form>

      </div>
    );
  }
}

const SelectionOfOrderManagement = observer(SelectionOfOrderManagementInner);

SelectionOfOrderManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfOrderManagement);
